/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CurrencyInputs */

const en__field_currency = /** @type {(inputs: _Field_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

const de__field_currency = /** @type {(inputs: _Field_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {_Field_CurrencyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_currency = /** @type {((inputs?: _Field_CurrencyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CurrencyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_currency(inputs)
	return de__field_currency(inputs)
});